import ModalBasicLayout from "../../../Modal/ModalBasicLayout";
import GenerateCampaignFormGoogle from "./GenerateCampaignFormGoogle";

const GenerateCampaignGoogle = ({
  initialData = {},
  modalOpen,
  onCloseModal,
  campaignID,
  context,
  onCallbackSave = () => {},
  verifyBlockAlert,
}) => {
  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={async () => {
        onCloseModal();
      }}
      fullWidth={true}
      maxWidth="md"
      scroll="paper"
      sxPaper={{
        maxWidth: 750,
      }}
    >
      <GenerateCampaignFormGoogle
        initialData={initialData}
        campaignID={campaignID}
        context={context}
        onCallbackSave={onCallbackSave}
        verifyBlockAlert={verifyBlockAlert}
      />
    </ModalBasicLayout>
  );
};

export default GenerateCampaignGoogle;
